import { render } from "./CustomerReview.vue?vue&type=template&id=3e7957e6&scoped=true"
const script = {}

import "./CustomerReview.vue?vue&type=style&index=0&id=3e7957e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7957e6"]])

export default __exports__